export default "__VITE_ASSET__vwcFF7RJ__"